export const models = {
  dark: 'dark',
  light: 'light',
};
